module.exports = __webpack_public_path__ + "components/intersport-discount-page/static/intersport-1-75ebccdda5ddfb191785d04f9dfc2cf3.webp";